import {isBefore} from 'date-fns';

import {QueueVideoTask} from '../types/QueueVideoTask';

export function checkIsTaskExpired(task: QueueVideoTask) {
  const now = new Date();

  return isBefore(task.expiredAt, now);
}
